import { create } from "zustand";
import { ProductsAPI } from "../Helpers/ConfigProvider";

const useReviewStore = create((set, get) => ({
  reviews: [],
  reviewHighLights: { Items: [] },
  loading: false,
  reviewHighLightsLoading: false,
  errors: [],
  createReviewErrors: [],
  tooManyRequests: false,
  createUnprocessableErrors: [],
  loadingCreateReview: false,
  getReviews: async () => {
    try {
      set({ loading: true });
      const response = await fetch(`${ProductsAPI}/Reviews/published`);
      if (!response.ok) {
      }
      const data = await response.json();
      set({ reviews: data });
      return data;
    } catch (error) {
      console.error("Error fetching reviews:", error);
      set({ reviews: [] });
      return [];
    } finally {
      set({ loading: false });
    }
  },
  getReviewHighlights: async (pageNo, pageSize) => {
    try {
      if (get().reviewHighLightsLoading) {
        return;
      }
      set({ loading: true, reviewHighLightsLoading: true });

      const response = await fetch(
        `${ProductsAPI}/Reviews/published/paged?page=${pageNo}&pageSize=${pageSize}`,
      );
      if (!response.ok) {
      }
      const data = await response.json();
      set({ reviewHighLights: data });
      return data;
    } catch (error) {
      console.error("Error fetching review highlights:", error);
      set({ reviewHighLights: [] });
      return [];
    } finally {
      set({ loading: false, reviewHighLightsLoading: false });
    }
  },
  getReviewsPaged: async (pageNo, pageSize) => {
    try {
      set({ loading: true });
      const response = await fetch(
        `${ProductsAPI}/Reviews/published/paged?page=${pageNo}&pageSize=${pageSize}`,
      );
      if (!response.ok) {
      }
      const data = await response.json();
      set({ reviews: data });
      return data;
    } catch (error) {
      console.error("Error fetching paged reviews:", error);
      set({ reviews: [] });
      return [];
    } finally {
      set({ loading: false });
    }
  },
  createReview: async (reviewData) => {

    set({  loadingCreateReview: true, createReviewErrors: [], tooManyRequests: false });

    try {
      const response = await fetch(`${ProductsAPI}/Reviews`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(reviewData),
      });

      if (!response.ok) {
        let errorData = null;
        try {
          errorData = await response.json();
        } catch {
          errorData = null;
        }

        let flattenedErrors = [];

        if (response.status === 400 && errorData && errorData.errors) {
          flattenedErrors = Object.values(errorData.errors).flat();
        }

        if (response.status === 429) {
          flattenedErrors = ["Too many requests. Please try again later."];
          set({ tooManyRequests: true });
        }

        if (response.status === 422 && errorData && errorData.Errors) {
          if (response.status === 422 && errorData?.Errors) {
            set({ createUnprocessableErrors: errorData.Errors });
          }
        }

        set({ createReviewErrors: flattenedErrors });
        return { ok: false, status: response.status, errors: flattenedErrors };
      }

      set({ createReviewErrors: [] });
      return { ok: true };
    } catch (error) {
      console.error("Error creating review:", error);
    }
    finally {
      set({ loadingCreateReview: false });
    }
  },
  resetErrors: () => {
    set({ createReviewErrors: [], tooManyRequests: false, createUnprocessableErrors: [] });
  },
}));

export default useReviewStore;
